import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';
import ImageResize  from 'quill-image-resize-module-react';
import VideoResize from 'quill-video-resize-module2';

import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb, InputGroup } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText, TextDate, ConvertDateToText, ButtonUploadFile } from "components/MyControl";
import Swal from "sweetalert2";
import moment from "moment";
import UtilClass from "api_ref/UtilClass";

export default function BlogManagementDetail() {
    const nav = useNavigate();
    const api = new ApiConection();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [createMode,setCreateMode] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});
    const urlPathName = window.location.pathname;
    const utilcls = new UtilClass();
    const customer = utilcls.getSessionStorage('_dcaas_8089');

    const blogFilePath = `BlogImages/${moment().format('YYYY')}`;
    const getData = async () => {
        const response = await api.getData(`api/BlogManagement/${id}`);
        
        if (response.status === true) {

            const response_photo = await getSlipFile(response.data.image_id);

            let data = {}
            data.title = response.data.title;
            data.description =response.data.description;
            data.blog_body = response.data.blog_body;
            data.written_by = response.data.written_by;
            data.image_id = response.data.image_id; 
            data.image_brob = (response_photo !== undefined)? URL.createObjectURL(response_photo) : undefined;
            data.release_date = ConvertDateToText(response.data.release_date);
            data.active = response.data.active;
            data.create_date = response.data?.create_date;
            data.modify_date = response.data?.modify_date;
            data.modify_by = response.data?.modify_by;

            setSimulate(data);
            setInitialData(data);
        }
    }

    const getSlipFile = async (id) => {
        if (id !== null && id !== undefined) {
            return await api.getFile(`api/file/${id}/preview`);
        } else {
            return undefined;
        }
    }



        const formats = [
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'color',
        'list',
        'bullet',
        'indent',
        'align',
        'link',
        'image',
        'video'
        ];
        
    Quill.register('modules/imageResize', ImageResize);
    Quill.register('modules/VideoResize', VideoResize);

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/blogmanagement/create')){
            setMode('edit');
            setCreateMode(true);
            let temp = simulate;
            temp.written_by = customer.show_name;
            setSimulate(temp)
        }
        
    },[urlPathName])


    useEffect(()=>{
        if(mode !== 'view'){
            if(simulate?.blog_body !== undefined)
            document.getElementsByClassName('ql-editor')[0].innerHTML = simulate?.blog_body
        }

    },[mode])

    useEffect(() => {
        getData();
    }, [])

    

    const handleSetSimulate = async (event) => {
    
        const { name, value, checked, type ,files} = event.target;

       
            if(type === 'checkbox'){
                setSimulate(preData => { return { ...preData, [name]: checked } });
            }else  if (type === "file") {
                setSimulate((prevData) => {
                    return { ...prevData, [name]: files ? files[0] : undefined || value };
                });
            }else {
                setSimulate(preData => { return { ...preData, [name]: value } });
            }
     }

     const handleSetSimulateBodyBlog = async (name,value)=>{
        setSimulate(preData => { return { ...preData, [name]: value } 
        });
     }

    const handleBreadcrumbClick = (e) => {
        nav('/blogmanagement');
    };
    
    const handleCancel = (event) => {
        if (createMode) {
            nav('/blogmanagement'); 
        } else {
            setSimulate(initialData);
            setMode('view');
        }
    }
    

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }
        const image_id = await uploadBlogImage(id);
        
        let rele_date = moment(simulate.release_date , 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss')

        let data = {
            title: simulate.title,
            description: simulate.description,
            blog_body: simulate.blog_body,
            written_by: simulate.written_by,
            image_id: image_id,
            release_date: rele_date,
            active: simulate.active,
        }

        if (urlPathName === (process.env.PUBLIC_URL+'/blogmanagement/create')){
            const response = await api.postData(`api/BlogManagement`, data)
            if (response.status === true) {

                nav('/blogmanagement');
            } else{
                setAlert(response.message);
            }
        } else {
            const response = await api.putData(`api/BlogManagement/${id}`, data);

            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        ////------------- หลัง่บันทึกเสร็จแล้ว ค่อยบันทึก รูป
        

        setLoading(false);
    }

    const uploadBlogImage = async (id)=>{
        let image_id = null;
        //debugger;
        if( (simulate?.image !== undefined && simulate?.image !== null) && (simulate?.image_id !== undefined || simulate?.image_id !== null )){
            let formdata = new FormData();
                formdata.append("files", simulate?.image);
                formdata.append("path", blogFilePath);
                formdata.append("ref_code", id);

                const responseUpload = await api.postFile(
                    `api/file/upload/paymentslip`,
                    formdata
                );

                if (responseUpload.status === true) {
                    handleSetSimulate({ target: { name: 'image_id', value: responseUpload.data.id } });
                    handleSetSimulate({ target: { name: 'image', value: URL.createObjectURL(simulate.image) } });
                    image_id = responseUpload.data.id;
                } else {
                    setAlert('ไม่สามารถอัปโหลดไฟล์ได้ กรุณาลองใหม่อีกครั้ง !!');
                    setLoading(false);
                    return;
                }

        }else if(simulate?.image_id !== undefined && simulate?.image_id !== null){
            image_id = simulate?.image_id;
        }

        return image_id;
    }

    const handleDelete = (id) => {
        Swal.fire({
            title: 'ต้องการลบข้อมูลผู้ใช้ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#727a82',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {
                api.deleteData(`api/BlogManagement/${id}`)
                .then((response) => {
                    if (response.status === true) {
                        Swal.fire('ลบสำเร็จ', '', 'success');
                        nav('/blogmanagement');
                    } else {
                        Swal.fire('เกิดข้อผิดพลาด', '', 'error');
                    }
                })
            }
        })
    }

    return (
        <Layout4Admin1>
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>จัดการบทความ</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'รายละเอียดบทความ' :
                                createMode === true ? 'สร้างบทความ' :
                                'แก้ไขบทความ'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'รายละเอียดบทความ' :
                                                createMode === true ? 'สร้างบทความ' :
                                                'แก้ไขบทความ'
                                            }
                                        </h5>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                    
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อบทความ <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'title'}
                                                    value={simulate?.title}
                                                    onChange={handleSetSimulate}
                                                    placeholder="ชื่อบทความ" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>บทความย่อ <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control as="textarea" rows={3}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'description'}
                                                    value={simulate?.description}
                                                    onChange={handleSetSimulate}
                                                    placeholder="บทความย่อ" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>ภาพปกบทความ</Form.Label>
                                                <div className={''}>
                                                    <ButtonUploadFile
                                                        readOnly={(mode === 'view') ? true : false}
                                                        name={"image"}
                                                        className={"btn btn-outline-secondary "}
                                                        label={"คลิกเพื่อแนบรูปภาพ"}
                                                        value={simulate?.image_id}
                                                        defaultPreview={simulate?.image_brob}
                                                        onChange={handleSetSimulate}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>เขียนโดย <span className='text-danger'>*</span></Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'written_by'}
                                                value={simulate?.written_by}
                                                onChange={handleSetSimulate}
                                                required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>วันที่เผยแพร่ <span className='text-danger'>*</span></Form.Label>
                                                <InputGroup className="flex-nowrap">
                                                            <TextDate 
                                                            name={'release_date'}
                                                            readOnly={(mode === 'view') ? true : false}
                                                            disabled={(mode === 'view') ? true : false}
                                                            value={(simulate?.release_date)}
                                                            onChange={handleSetSimulate} 
                                                            required={true} />
                                                </InputGroup>
                                                <Form.Text>*วันที่เผยแพร่ มีผลต่อการแสดงบนหน้าจอบทความ</Form.Text>
                                            </Form.Group>
                                                                                
                                        </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่สร้าง</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.create_date)}</Form.Label>
                                        </Form.Group>

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">วันที่แก้ไขล่าสุด</Form.Label>
                                                <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                            </Form.Group>
                                            
                                        }

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">แก้ไขโดย</Form.Label>
                                                <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>Active</Form.Label>
                                        <Form.Check type={'switch'}
                                            id={'active'}
                                            name={'active'}
                                            disabled={(mode === 'view') ? true : false}
                                            onChange={event => handleSetSimulate(event)}
                                            checked={simulate?.active}
                                            label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                        />
                                    </Form.Group>
                                    </Col>
                                    <Form.Group className='mb-3'>
                                        <Form.Label className='label-title'>เนื้อหาบทความ</Form.Label>
                                        {
                                            mode === 'view' &&
                                                
                                            <div id='article_id' className='shadow' style={{ padding: '20px'}}  dangerouslySetInnerHTML={{ __html: simulate?.blog_body?.replace(/  /gi,'&nbsp;') }} />
                                               
                                        }
                                        {
                                            
                                        }
                                        {
                                            (createMode === true || mode !== 'view')  &&
                                            <div>
                                            <ReactQuill
                                                name='blog_body'
                                                theme="snow" 
                                                readOnly={mode === 'view'}
                                                value={simulate?.blog_body}
                                                onChange={event => handleSetSimulateBodyBlog('blog_body',event)}
                                                formats={formats}
                                                modules={{
                                                    imageResize: {
                                                        parchment: Quill.import('parchment'),
                                                        modules: ['Resize', 'DisplaySize']
                                                    },
                                                    VideoResize: {
                                                        modules: [ 'Resize', 'DisplaySize' ],
                                                        tagName: 'iframe', 
                                                    },
                                                    toolbar: [
                                                      [{ 'header': [1, 2, 3, false] }],
                                                      [{ size: [] }],
                                                      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                      [{ 'color': [] }, { 'background': [] }],  
                                                      [{'list': 'ordered'}, {'list': 'bullet'}],  
                                                      [{ 'indent': '-1'}, { 'indent': '+1' }],
                                                      [{ 'align': null}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                                                      ['link', 'image', 'video'],
                                                      ['clean']
                                                    ],
                                                }}
                                            />
                                        </div>
                                        }
                                    </Form.Group>
                                    {
                                        mode !== 'view' &&
                                        <p>*หมายเหตุ: หากต้องการใส่ลิงค์ให้ทำการพิมพ์ลงไปก่อน จากนั้นก็คลุมข้อความแล้วกด"ลิงค์"ที่เครื่องมือ</p>
                                    }
                                    
                                </Row>
                            </div>

                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-danger" type="button" className=''
                                        onClick={event => handleDelete(id)}>
                                        ลบ
                                        <i className="ms-2 fa-solid fa-trash"></i>
                                    </Button>
                                }
                            </Col>

                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

                            {
                            <Row>
                                <Col>
                                    {createMode && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                    {!createMode && mode === 'edit' && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                บันทึก
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}